export const API_PATH = {
  questionnaires: 'questionnaires/',
  consentement: 'consentement/',
  reponse: 'reponse/'
}

export const LANG_STORAGE_KEY = 'lang'
